/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {unlinkInstrumentLink} from '../api'

export const useMutationUnlinkInstrumentLink = createReactQueryMutationHook('unlinkInstrumentLink', unlinkInstrumentLink)
